import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

import { SCALE } from './constants';
import { FRAME_WIDTH, GAP } from './constants';
import { INITX, INITY } from './constants';
import { CANVASW, CANVASH } from './constants';

import { dN_Rect } from './lib/d_rect';
import { displaySizes } from './lib/displaySizes';
import { formatToFractional } from './controls/conversions';
import { drawGrills } from './lib/drawGrills';
import { drawHanger } from './lib/drawHanger';

const DrawPatioDoor = ({ doorData = null, toLeft = 0, zoom = 100, useStyle = true }) => {
  const svgRef = useRef(null);
  const canvasW = CANVASW;
  const canvasH = CANVASH;

  useEffect(() => {
    if (!doorData) return;

    const frameWidth = FRAME_WIDTH;
    let initX = INITX - toLeft;
    if (!doorData?.flipped) {
      initX = initX + 60;
    }
    const initY = INITY;
    const gap = GAP;

    const patioDoorType = doorData?.frameData?.patioDoorType?.value || 'Sliding';
    const pdSections = patioDoorType === 'QuadSliding' ? 4
                     : patioDoorType === 'TripleSliding' ? 3
                     : 2;

    const totalWidth = (parseFloat(doorData?.frameData?.unitWidth_d) || 72) * SCALE;
    const totalHeight = (parseFloat(doorData?.frameData?.unitHeight_d) || 80) * SCALE;
    const panelWidth = (totalWidth - (pdSections - 1) * gap - 2 * pdSections * frameWidth) / pdSections;
    const panelHeight = totalHeight;

    const finishColor = doorData.flipped
      ? doorData?.finish?.exteriorColor?.value || 'white'
      : doorData?.finish?.interiorColor?.value || 'white';

    doorData.frameData.X = totalWidth;
    doorData.frameData.Y = totalHeight;

    const svg = initSvg();

    const patioDoorRects = [];
    for (let i = 0; i < pdSections; i++) {
      patioDoorRects.push({
        w: panelWidth,
        h: panelHeight,
        frameWidth,
        frameColor: finishColor,
        lineFrameColor: 'black',
        lineFrameThickness: 1,
        outerStrokeColor: 'black',
        outerStrokeWidth: 1,
        color: '#EDF9FF'
      });
    }

    dN_Rect(svg, gap, initX, initY, patioDoorRects, {
      labelText: null,
      labelOptions: {
        fontSize: 36,
        fontColor: 'black',
        fontOpacity: 0.2
      },
      drawFrame: true
    });

    //draw Grills...
    let xOffset = initX;
    for (let i = 0; i < pdSections; i++) {
      drawGrills(svg, i + 1,
                  xOffset, initY,
                  panelWidth,
                  panelHeight,
                  frameWidth,
                  doorData, false);
      xOffset += panelWidth + 2 * frameWidth + gap + 2;
    }
    
    if (doorData?.flipped) {
      const w = totalWidth;
      const h = totalHeight;
      const w_label = formatToFractional(parseFloat(doorData?.frameData?.unitWidth_d) || 0);
      const h_label = formatToFractional(parseFloat(doorData?.frameData?.unitHeight_d) || 0);
      const uHeight = 0;
      const uHeight_label = '';
      displaySizes(svg, initX, initY, w + frameWidth - 2, 
                                      h + 2*frameWidth, w_label, 
                                      h_label, uHeight, uHeight_label, frameWidth);
    }

    xOffset = initX;
    if (doorData?.flipped === false){
        for (let i = 0; i < pdSections; i++) {
          if (doorData?.frameData?.patioDoorType?.value === 'Sliding'){
            if (i === 1){ //draw Left on A1
                drawHanger(svg, xOffset - frameWidth + gap/2 + panelWidth + frameWidth + gap/2, 
                initY + panelHeight/2, 
                frameWidth-2, 2*frameWidth, 'white', 'black');                        
            }
          }
          if (doorData?.frameData?.patioDoorType?.value === 'TripleSliding'){
            if (i === 1){ //draw Right on A2
                drawHanger(svg, xOffset - frameWidth + gap/2, 
                            initY + panelHeight/2, 
                            frameWidth-2, 2*frameWidth, 'white', 'black');
            }            
          }
          if (doorData?.frameData?.patioDoorType?.value === 'QuadSliding'){
            if (i === 1){ //draw Left on A3
                drawHanger(svg, xOffset - frameWidth + gap/2 + panelWidth + frameWidth + gap/2, 
                initY + panelHeight/2, 
                frameWidth-2, 2*frameWidth, 'white', 'black');                        
            }  
            if (i === 2){ //draw Right on A2
                drawHanger(svg, xOffset - frameWidth + gap/2, 
                            initY + panelHeight/2, 
                            frameWidth-2, 2*frameWidth, 'white', 'black');
            }            
         
          }
          xOffset += panelWidth + 2 * frameWidth + gap + 2;
      }//for
    }//if flipped
    

  }, [doorData]);

  function initSvg() {
    d3.select(svgRef.current).selectAll('*').remove();

    const svgElement = d3
      .select(svgRef.current)
      .attr('width',  ((doorData?.frameData?.X + INITX + 65) || canvasW) * zoom)
      .attr('height', ((doorData?.frameData?.Y + INITY + 50) || canvasH) * zoom)
      .style('border', '0px solid black');

    return svgElement
      .append('g')
      .attr('transform', `scale(${zoom})`);
  }

  const style = {};

  return (
    <div className="scaled-image" style={style}>
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default DrawPatioDoor;
